module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/nudge/hourglass-nudge-e52591ef14ff9ded4509a387103da7dc.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/nudge/hourglass-nudge.svg
// module id = yJna
// module chunks = 24